import Reac, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { CrossIconRounded } from "../../../icons/Icons";
import RadioButton from "../../../components/RadioButton/RadioButton";
import {
  convertToGB,
  convertKBToGBNumeric,
  convertMBToKB,
  convertMBToGB,
} from "../../../common";
import { useDispatch, useSelector } from "react-redux";
import {
  getStorageAsync,
} from "../../../reducers/subscription-reducers";

const planReasons = [
  "Plan is too expensive",
  "Do not need some features",
  "Organization Budget Cuts",
  "Others",
];

const DowngradeModal = ({
  downgradePlan,
  handleModal,
  confirm,
  request,
  setRequest,
  selectedPlanData,
  metaData,
}) => {
  const dispatch = useDispatch();
  const { storageData } = useSelector(
    (state) => state.subscription
  );
  console.log(selectedPlanData, "selectedPlanData");
  console.log(metaData, "metaData");
  const [showOther, setShowOther] = useState(false);

  useEffect(() => {
    dispatch(getStorageAsync());
  }, []);

  const onhandlePlan = (e) => {
    if (e.target.value === planReasons[3]) {
      setShowOther(true);
      setRequest({ ...request, planReason: e.target.value });
    } else {
      setShowOther(false);
      setRequest({ planReason: e.target.value, other: "" });
    }
  };
  const onhandleOther = (e) => {
    setRequest({ ...request, other: e.target.value });
  };
  return (
    <>
      <Modal.Header closeButton>
        {/* <button className="close" onClick={() => handleModal(false)}>
          <span>&times;</span>
        </button> */}
      </Modal.Header>

      <Modal.Body className="pt-4 pb-4">
        <h3 className="text-gray-100">Downgrade my plan</h3>
        <p className="text-gray-300 h5 font-normal mb-0 mt-1">
          {/* Downgrading will reduce feature limits and access to advanced
          capabilities. */}
          Review the changes below before downgrading to ensure the new plan meets your needs.
        </p>
        <div className="w-605 mt-4 border-top border-bottom border-gray-400">
          <div className="d-flex flex-col flex-grow usagePlanBox h-100 align-items-start">
            <div className="first pt-10 h-100 ps-2">
              <span className="text-base-100 text-lg font-bold py-1 px-12 rounded-pill mb-12 d-inline-block">
                Dummy for space manage
              </span>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                Active Users
              </p>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                Storage Utilization
              </p>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                Processes
              </p>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                Sequences
              </p>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                Modules
              </p>
            </div>
            <div className="second pt-10 h-100 text-center">
              <span className="text-base-100 text-lg font-medium bg-primary-200 py-1 px-12 rounded-pill mb-12 d-inline-block">
                Current Usage
              </span>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                {metaData?.included_users}
              </p>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                {convertKBToGBNumeric(
                  convertMBToKB(
                    parseInt(metaData?.storage) *
                      parseInt(metaData?.included_users)
                  )
                )}
                GB
              </p>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                {metaData?.process === "-1" ? "Unlimited" : metaData?.process}
              </p>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                {metaData?.sequence === "-1" ? "Unlimited" : metaData?.sequence}
              </p>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                {metaData?.modules === "-1" ? "Unlimited" : metaData?.modules}
              </p>
            </div>
            <div className="third pt-10 h-100 text-center">
              <span className="text-primary-200 text-lg font-bold py-1 px-12 rounded-pill mb-12 d-inline-block">
                New Plan Limits
              </span>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                {selectedPlanData?.metaData?.included_users}
              </p>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                {convertToGB(selectedPlanData?.metaData?.storage)}
              </p>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                {selectedPlanData?.metaData?.process === "-1"
                  ? "Unlimited"
                  : selectedPlanData?.metaData?.process}
              </p>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                {selectedPlanData?.metaData?.sequence === "-1"
                  ? "Unlimited"
                  : selectedPlanData?.metaData?.sequence}
              </p>
              <p className="mb-12 text-gray-1200 font-medium text-lg">
                {selectedPlanData?.metaData?.modules === "-1"
                  ? "Unlimited"
                  : selectedPlanData?.metaData?.modules}
              </p>
            </div>
          </div>
        </div>
        <div className="mt-40">
          <h5 className="font-bold text-gray-100 mb-12">
            Limited Features After Downgrade
          </h5>
          <ul className="p-0">
            <li className="d-flex justify-content-start align-items-center gap-2 text-gray-1200 font-medium text-lg mb-12">
              <CrossIconRounded />
              {/* <span>Active users reduced to {storageData?.usedSeatQuantity} from {metaData?.max_users}.</span> */}
              <span>Active users reduced to {selectedPlanData?.metaData?.included_users} from {metaData?.included_users}.</span>
              {/* <span>Adding more than {metaData?.max_users} active users</span> */}
            </li>
            <li className="d-flex justify-content-start align-items-center gap-2 text-gray-1200 font-medium text-lg mb-12">
              <CrossIconRounded />
              <span>
                Storage capacity cut to {convertToGB(selectedPlanData?.metaData?.storage)} from{" "}
                {convertKBToGBNumeric(
                  convertMBToKB(
                    parseInt(metaData?.storage) *
                      parseInt(metaData?.included_users)
                  )
                )}GB.
              </span>
              {/* <span>
                Content storage more than{" "}
                {convertKBToGBNumeric(
                  convertMBToKB(
                    parseInt(metaData?.storage) *
                      parseInt(metaData?.included_users)
                  )
                )}
                GB
              </span> */}
            </li>
            <li className="d-flex justify-content-start align-items-center gap-2 text-gray-1200 font-medium text-lg mb-12">
              <CrossIconRounded />
              <span>
                {/* {metaData?.process === "-1" ? "Unlimited" : metaData?.process}
                {metaData?.sequence === "-1" ? "Unlimited" : metaData?.sequence}
                {metaData?.modules === "-1" ? "Unlimited" : metaData?.modules} */}
                Processes diminished to {selectedPlanData?.metaData?.process === "-1" ? "Unlimited" : selectedPlanData?.metaData?.process},{" "}
                Sequences limited to {selectedPlanData?.metaData?.sequence === "-1" ? "Unlimited" : selectedPlanData?.metaData?.sequence},{" "}
                and modules capped at {selectedPlanData?.metaData?.modules === "-1" ? "Unlimited" : selectedPlanData?.metaData?.modules}.
                {/* Creating more than{" "}
                {metaData?.process === "-1" ? "Unlimited" : metaData?.process}{" "}
                processes,{" "}
                {metaData?.sequence === "-1" ? "Unlimited" : metaData?.sequence}{" "}
                sequences &{" "}
                {metaData?.modules === "-1" ? "Unlimited" : metaData?.modules}{" "}
                modules */}
              </span>
            </li>
            <li className="d-flex justify-content-start align-items-center gap-2 text-gray-1200 font-medium text-lg mb-12">
              <CrossIconRounded />
              <span>No Access to community knowledge base videos.</span>
              {/* <span>Videos of community knowledge base</span> */}
            </li>
            <li className="d-flex justify-content-start align-items-center gap-2 text-gray-1200 font-medium text-lg mb-12">
              <CrossIconRounded />
              <span>
                Support response time extended to 2 days.
                {/* Prompt support desk turnaround (it will take 2 business days) */}
              </span>
            </li>
          </ul>
        </div>
        <div className="mt-40">
          <h5 className="font-bold text-gray-100 mb-12">
            Let us know the issue you are facing with the current plan
          </h5>
          <ul className="p-0">
            {planReasons.map((planReasonData) => (
              <li className="d-flex justify-content-start align-items-center text-gray-1200 font-medium text-lg mb-12">
                <div className="mtm-32">
                  <RadioButton
                    name="plan"
                    onChange={(e) => onhandlePlan(e)}
                    value={planReasonData}
                    checked={request.planReason === planReasonData}
                  />
                  {/* <input
                    type="radio"
                    name="plan"
                    onChange={(e) => onhandlePlan(e)}
                    value={planReasonData}
                    checked={request.planReason === planReasonData}
                  /> */}
                </div>
                {planReasonData && <span>{planReasonData}</span>}
              </li>
            ))}
            {/* <li className="d-flex justify-content-start align-items-center text-gray-1200 font-medium text-lg mb-12">
              <div className="mtm-32">
                <RadioButton />
              </div>
              <span>Plan is too expensive</span>
            </li>
            <li className="d-flex justify-content-start align-items-center text-gray-1200 font-medium text-lg mb-12">
              <div className="mtm-32">
                <RadioButton />
              </div>
              <span>Do not need some features</span>
            </li>
            <li className="d-flex justify-content-start align-items-center text-gray-1200 font-medium text-lg mb-12">
              <div className="mtm-32">
                <RadioButton />
              </div>
              <span>Organization Budget Cuts</span>
            </li>
            <li className="d-flex justify-content-start align-items-center text-gray-1200 font-medium text-lg mb-12">
              <div className="mtm-32">
                <RadioButton />
              </div>
              <span>Others</span>
            </li> */}
          </ul>
          {showOther && (
            <div className="mt-4">
              <h6 className="text-gray-1200 font-medium">
                Provide a detailed reason for downgrading{" "}
                <span className="text-primary-100">*</span>
              </h6>
              <div className="mt-3 w-472">
                <textarea
                  rows="3"
                  placeholder="Add description"
                  onChange={(e) => onhandleOther(e)}
                >
                  {request.other}
                </textarea>
              </div>
            </div>
          )}
          {/* <div className="mt-4">
            <h6 className="text-gray-1200 font-medium">
              Provide a detailed reason for downgrading{" "}
              <span className="text-primary-100">*</span>
            </h6>
            <div className="mt-3 w-472">
                <textarea rows="3" placeholder='Add description'></textarea>
            </div>
          </div> */}
        </div>
        {/* <div className="">
          {planReasons.map((planReasonData) => (
            <div className="mb-2 pb-1">
              <label className="rarioBox d-flex align-items-center">
                <input
                  type="radio"
                  name="plan"
                  onChange={(e) => onhandlePlan(e)}
                  value={planReasonData}
                  checked={request.planReason === planReasonData}
                />
                <span className="radioBoxCheck"> </span>
                {planReasonData && (
                  <span className="ps-1 text-sm font-medium">
                    {planReasonData}
                  </span>
                )}
              </label>
            </div>
          ))}
        </div> */}
      </Modal.Body>
      <Modal.Footer className="justify-content-start gap-2">
        <Button
          variant="primary"
          size="lg"
          className="border-0 pe-"
          onClick={() => handleModal(false)}
        >
          Cancel
        </Button>
        <Button
          variant="white"
          size="lg"
          onClick={confirm}
          disabled={
            request.planReason
              ? request.planReason === planReasons[3]
                ? request.other
                  ? false
                  : true
                : false
              : true
          }
        >
          Raise downgrade request
        </Button>
      </Modal.Footer>
      {/* <Modal.Footer className="justify-content-end btnFooter gap-2">
        <Button
          variant="white"
          size="large"
          onClick={() => handleModal(false)}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          size="large"
          className="border-0"
          onClick={confirm}
          disabled={
            request.planReason
              ? request.planReason === planReasons[3]
                ? request.other
                  ? false
                  : true
                : false
              : true
          }
        >
          Submit
        </Button>
      </Modal.Footer> */}
    </>
  );
};

export default DowngradeModal;
